import propertyApi from "@/api/propertyApi";
import { CompanyDTO } from "./company";
import FloorPlan from "./floor";
import Location from "./location";
import RepairContent from "./repairContent";
import { UserDTO } from "./user";
import moment from "moment";
import _ from "lodash";

export enum REPAIR_TYPE {
  HAVE_HISTORY = 1,
  HAVE_NO_HISTORY = 2,
  UNKNOW_HISTORY = 3,
}

export const REPAIR_TYPE_NAME = {
  [REPAIR_TYPE.HAVE_HISTORY]: '修繕履歴あり',
  [REPAIR_TYPE.HAVE_NO_HISTORY]: '修繕履歴なし',
  [REPAIR_TYPE.UNKNOW_HISTORY]: '修繕履歴不明',
}

export interface IProperty {
  id: string;
  acreage: string;
  company: CompanyDTO;
  company_id: string;
  date_of_construction: string;
  floor_plan_id: string;
  floor_plan_type: string;
  floor_plan: FloorPlan;
  has_contract: boolean;
  location: Location;
  exact_address: string;
  manage_number: string;
  name: string;
  person_in_charge: UserDTO;
  person_in_charge_id: string;
  owner_company_id: string;
  owner_company: CompanyDTO;
  room_number: string;
  structure: string;
  zip_code: string;
  remarks: string;
  type: REPAIR_TYPE;
  allow_change: number;
  repair_contents?: RepairContent[];
  repair_contents_tmp?: RepairContent[];
}
export class PropertyDTO implements IProperty {
  id: string;
  acreage: string;
  company: CompanyDTO;
  company_id: string;
  date_of_construction: string;
  floor_plan_id: string;
  floor_plan_type: string;
  floor_plan: FloorPlan;
  has_contract: boolean;
  location: Location;
  exact_address: string;
  manage_number: string;
  name: string;
  person_in_charge: UserDTO;
  person_in_charge_id: string;
  owner_company_id: string;
  owner_company: CompanyDTO;
  room_number: string;
  structure: string;
  zip_code: string;
  remarks: string;
  type: REPAIR_TYPE;
  allow_change: number;
  self_serve = 0;
  repair_contents?: RepairContent[];
  repair_contents_tmp?: RepairContent[];
}

export default class Property extends PropertyDTO {
  constructor(dto?: PropertyDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      dto.location && (this.location = new Location(dto.location));
      dto.repair_contents && (this.repair_contents = dto.repair_contents.map(item => new RepairContent(item)));
      dto.floor_plan && (this.floor_plan = new FloorPlan(dto.floor_plan));
      this.repair_contents_tmp = [];
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      acreage: null,
      company_id: null,
      date_of_construction: null,
      floor_plan_id: null,
      floor_plan_type: null,
      manage_number: null,
      exact_address: null,
      name: null,
      person_in_charge_id: null,
      person_in_charge: new UserDTO(),
      owner_company_id: null,
      room_number: null,
      structure: null,
      zip_code: null,
      location: new Location(),
      floor_plan: new FloorPlan(),
      remarks: null,
      type: REPAIR_TYPE.HAVE_HISTORY,
      allow_change: 1,
      repair_contents: [],
      repair_contents_tmp: [],
    });
  }

  public save() {
    if (this.id) {
      return propertyApi.update(this);
    } else {
      return propertyApi.create(this);
    }
  }

  public async remove() {
    return await propertyApi.remove(this.id);
  }

  public async updateCompany() {
    return await propertyApi.updateCompany(this);
  }

  get contractStatus() {
    return this.has_contract ? "on" : "off";
  }

  get locationName() {
    return (
      this.location.prefecture + this.location.area + this.location.address
    );
  }
  get exactAddress() {
    return (
      (this.exact_address !== null) ? this.exact_address : ""
    );
  }
  get personInCharged() {
    if (this.owner_company && this.person_in_charge) {
      return this.owner_company.name + " " + this.person_in_charge.username;
    }
    return "";
  }

  get personInChargedName() {
    if (this.person_in_charge) {
      return this.person_in_charge ? this.person_in_charge.username : "";
    }
  }

  get companyName() {
    return this.company ? this.company.name : "";
  }

  get fullname() {
    return this.locationName + this.name + this.room_number;
  }

  get shortName() {
    return this.name + this.room_number;
  }

  get totalContructionDayFormat() {
    if (!this.totalContructionDay) {
      return "";
    }
    const totalDays = this.totalContructionDay;
    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = Math.floor((totalDays % 365) % 30);

    return `築年数${years}年${months}ヶ月${days}日`;
  }

  get totalContructionDay() {
    if (!this.date_of_construction) {
      return 0;
    }
    const dateContruction = moment(this.date_of_construction, 'YYYY-M-D', true);
    return moment().diff(dateContruction, 'days');
  }

  get typeName() {
    return REPAIR_TYPE_NAME[this.type];
  }

  public tranformRequest() {
    const dataTranform = _.cloneDeep(this);
    if (dataTranform.id) {
      delete dataTranform.repair_contents;
      delete dataTranform.repair_contents_tmp;
    } else {
      dataTranform.repair_contents = dataTranform.repair_contents_tmp.map(item => item.tranformRequest());
      delete dataTranform.repair_contents_tmp;
    }
    console.log(dataTranform);
    return dataTranform;
  }
}
